export const DASHBOARD = '/dashboard';
export const SUBSCRIPTION_PAGE = '/subscription';
export const CREATE_REQUEST = '/requests/add';
